import { AppBar, Box, Button, Checkbox, Container, Drawer, FormControl, FormControlLabel, Icon, InputLabel, Select, Slider,Typography, useMediaQuery } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useTheme } from '@mui/material/styles';
import { useGetAllBrandsQuery, useAddBrandMutation, useGetAllStoragesQuery, useAddStorageMutation, useAddColorMutation, useGetAllColorsQuery, useGetAllActiveSmartphonesQuery, useGetAllActiveChargersQuery, useGetAllActiveHeadphonesQuery, useGetAllActivePhonecasesQuery, useAddMaterialMutation, useGetAllMaterialsQuery, useGetAllModelsQuery, useAddModelMutation } from '../../../features/fullApi';
import AddIcon from '@mui/icons-material/Add';
import CreateBrandDialog from '../../Modals/CreateBrandDialog';
import CreateStorageDialog from '../../Modals/CreateStorageDialog';
import CreateColorDialog from '../../Modals/CreateColorDialog';
import CreateMaterialDialog from '../../Modals/CreateMaterialDialog';
import CreateModelDialog from '../../Modals/CreateModelDialog';
import Brand from '../SidebarOptions/Brand/Brand';
import Storage from '../SidebarOptions/Storage/Storage'
import Color from '../SidebarOptions/Color/Color'
import './Sidebar.css'
import { useNavigate } from 'react-router-dom';
import Material from '../SidebarOptions/Material/Material';
import Model from '../SidebarOptions/Model/Model';

const minDistance = 10;
let drawerWidth = 350;
const Sidebar = ({type, handleFilterProducts, showSidebar, setShowSidebar}) => {

    const user = JSON.parse(localStorage.getItem('user'))

    const {data:brands, error, isLoading} = useGetAllBrandsQuery();
    const {data:materials, error: errorMaterials, isLoading:isLoadingMaterials} = useGetAllMaterialsQuery();
    const {data:models, error: errorModels, isLoading:isLoadingModels} = useGetAllModelsQuery();
    const {data:storages, error: errorStorages, isLoading: isLoadingStorages} = useGetAllStoragesQuery();
    const {data:colors, error: errorColors, isLoading: isLoadingColors} = useGetAllColorsQuery();
    const {data:products, error:errorProducts, isLoading:isLoadingProducts} = useGetAllActiveSmartphonesQuery()

    const [createBrand] = useAddBrandMutation()
    const [createStorage] = useAddStorageMutation()
    const [createColor] = useAddColorMutation()
    const [createMaterial] = useAddMaterialMutation()
    const [createModel] = useAddModelMutation()

    const [max, setMax] = useState(0)

    useEffect(() => {
      if(!isLoadingProducts) {
        getMaxProductPrice()
      }
    }, [isLoadingProducts])

    const getMaxProductPrice = () => {
      let mx = 0
      products?.map(product => {
        if(product.price > mx) {
          mx = product.price
        }
      })
      setMax(mx)
      setPrice([0, mx])
    }


    const [price, setPrice] = useState([0, 0])

    const handlePrice = (event, newValue, activeThumb) => {
      if (!Array.isArray(newValue)) {
        return;
      }
  
      if (activeThumb === 0) {
        setPrice([Math.min(newValue[0], price[1] - minDistance), price[1]]);
      } else {
        setPrice([price[0], Math.max(newValue[1], price[0] + minDistance)]);
      }
    };
 
  //constructing the boolean brands checked array
  const [brandsObj, setBrandsObj] = useState({})
  const [brandsObjInitial, setBrandsObjInitial] = useState({})
  useEffect(() => {
    if(!isLoading) {
      Object.keys(brands).forEach(ele => {
        let key = brands[ele].brandName
          brandsObj[key] = false;
          brandsObjInitial[key] = false;
      });
    }
  }, [brands, brandsObj, brandsObjInitial, isLoading])

    //constructing the boolean colors checked array
    const [colorsObj, setColorsObj] = useState({})
    const [colorsObjInitial, setColorsObjInitial] = useState({})

    useEffect(() => {
      if(!isLoadingColors) {
        Object.keys(colors).forEach(ele => {
          let key = colors[ele].colorName
            colorsObj[key] = false;
            colorsObjInitial[key] = false;
        });
      }
    }, [colors, isLoadingColors])


    const [materialsObj, setMaterialsObj] = useState({})
    const [materialsObjInitial, setMaterialsObjInitial] = useState({})
    useEffect(() => {
      if(!isLoadingMaterials) {
        Object.keys(materials).forEach(ele => {
          let key = materials[ele].colorName
            materialsObj[key] = false;
            materialsObjInitial[key] = false;
        });
      }
    }, [materials, isLoadingMaterials])


    const [modelsObj, setModelsObj] = useState({})
    const [modelsObjInitial, setModelsObjInitial] = useState({})
    useEffect(() => {
      if(!isLoadingModels) {
        Object.keys(models).forEach(ele => {
          let key = models[ele].modelName
            modelsObj[key] = false;
            modelsObjInitial[key] = false;
        });
      }
    }, [models, isLoadingModels, isLoadingModels])

  //constructing the boolean storages checked array
  const [storagesObj, setStoragesObj] = useState({})
  const [storagesObjInitial, setStoragesObjInitial] = useState({})
  useEffect(() => {
    if(!isLoadingStorages) {
      Object.keys(storages).forEach(ele => {
          let key = storages[ele].amount + storages[ele].type
          storagesObj[key] = false;
          storagesObjInitial[key] = false;
      });
    }
  }, [storages, storagesObj, storagesObjInitial, isLoading])


    const [brandsSelected, setBrandsSelected] = useState(JSON.parse(sessionStorage.getItem('brandsSelected')) ? JSON.parse(sessionStorage.getItem('brandsSelected')) : brandsObj)
    const [colorsSelected, setColorsSelected] = useState(JSON.parse(sessionStorage.getItem('colorsSelected')) ? JSON.parse(sessionStorage.getItem('colorsSelected')) : colorsObj)
    const [storagesSelected, setStoragesSelected] = useState(JSON.parse(sessionStorage.getItem('storagesSelected')) ? JSON.parse(sessionStorage.getItem('storagesSelected')): storagesObj)
    const [materialsSelected, setMaterialsSelected] = useState(JSON.parse(sessionStorage.getItem('materialsSelected')) ? JSON.parse(sessionStorage.getItem('materialsSelected')): materialsObj)
    const [modelsSelected, setModelsSelected] = useState(JSON.parse(sessionStorage.getItem('modelsSelected')) ? JSON.parse(sessionStorage.getItem('modelsSelected')): modelsObj)


    const [openCreateStorage, setOpenCreateStorage] = useState(false)
    const [openCreateBrand, setOpenCreateBrand] = useState(false)
    const [openCreateColor, setOpenCreateColor] = useState(false)
    const [openCreateMaterial, setOpenCreateMaterial] = useState(false)
    const [openCreateModel, setOpenCreateModel] = useState(false)

    const [updated, setUpdated] = useState(false)

    const [filteredBrands, setFilteredBrands] = useState([])
    const [filteredStorages, setFilteredStorages] = useState([])
    const [filteredColors, setFilteredColors] = useState([])
    const [filteredModels, setFilteredModels] = useState([])

    const handleFilterOptions = async () => {
      let colorsIds = []
      let brandsIds = []
      let storagesIds = []
      let materialsIds = []
      let modelsIds = []
      let colorArr = []
      let materialArr = []
      let brandArr = []
      let storageArr = []
      let modelArr = []
      let filtered = []
      let newUrl = ""


      if(type === "smartphone") {
      sessionStorage.setItem("colorsSelected", JSON.stringify(colorsSelected))
      sessionStorage.setItem("brandsSelected", JSON.stringify(brandsSelected))
      sessionStorage.setItem("storagesSelected", JSON.stringify(storagesSelected))
      sessionStorage.setItem("modelsSelected", JSON.stringify(modelsSelected))

      if(Object.keys(colorsSelected).length > 0) {
        let entered = true
        Object.keys(colorsSelected).forEach(function(key, index) {
            if(colorsSelected[key]) {
              if(entered) {
                newUrl+="___colors="
                entered = false
              }
              colorArr.push(key)
              newUrl+=key + '&'
            }
        });
        if(!entered) {
          newUrl = newUrl.slice(0, -1)
        }
      }

      if(Object.keys(storagesSelected).length > 0) {
        let entered = true
        Object.keys(storagesSelected).forEach(function(key, index) {
          if(storagesSelected[key]) {
            if(entered) {
              newUrl+="___storages="
              entered = false
            }
            storageArr.push(key)
            newUrl+=key + '&'
          }
        });
        if(!entered) {
          newUrl = newUrl.slice(0, -1)
        }
      }

      if(Object.keys(brandsSelected).length > 0) {
        let entered = true
        Object.keys(brandsSelected).forEach(function(key, index) {
          if(brandsSelected[key]) {
            if(entered) {
              newUrl+="___brands="
              entered = false
            }
            brandArr.push(key)
            newUrl+=key + '&'
          }
        });
        if(!entered) {
          newUrl = newUrl.slice(0, -1)
        }
      }

      if(Object.keys(modelsSelected).length > 0) {
        let entered = true
        Object.keys(modelsSelected).forEach(function(key, index) {
          if(modelsSelected[key]) {
            if(entered) {
              newUrl+="___models="
              entered = false
            }
            modelArr.push(key)
            newUrl+=key + '&'
          }
        });
        if(!entered) {
          newUrl = newUrl.slice(0, -1)
        }
      }

      colors?.map(color => {
        if(colorArr.includes(color.colorName)) {
          colorsIds.push(color._id)
        }
      })

      storages?.map(storage => {
        if(storageArr.includes(storage.amount+storage.type)) {
          storagesIds.push(storage._id)
        }
      })

      brands?.map(brand => {
        if(brandArr.includes(brand.brandName)) {
          brandsIds.push(brand._id)
        }
      })

      materials?.map(material => {
        if(materialArr.includes(material.materialName)) {
          materialsIds.push(material._id)
        }
      })

      models?.map(model => {
        if(modelArr.includes(model.modelName)) {
          modelsIds.push(model._id)
        }
      })

      if(colorsIds.length === 0) {
        colors?.map(color => {
          colorsIds.push(color._id)
        })
      }

      if(brandsIds.length === 0) {
        brands?.map(brand => {
          brandsIds.push(brand._id)
        })
      }

      if(materialsIds.length === 0) {
        materials?.map(material => {
          materialsIds.push(material._id)
        })
      }

      if(storagesIds.length === 0) {
        storages?.map(storage => {
          storagesIds.push(storage._id)
        })
      }

      if(modelsIds.length === 0) {
        models?.map(model => {
          modelsIds.push(model._id)
        })
      }

      if(type==="smartphone") {
          products?.map(product => 
            {
              if(
                (brandsIds?.includes(product.brandId)) 
                 && (colorsIds?.includes(product.colorId)) 
                 && (storagesIds?.includes(product.storageId))
                 //&&(modelsIds?.includes(product.modelId))
                 && (product.price >= price[0] && product.price <= price[1])
              ) {
                console.log("###PUSHING###", product)
                filtered.push(product)
              }
            }
          )
      }
      console.log("FILTERED IS", filtered)
      if(type==="phonecase") {
        products?.map(product => 
          {
            if(
              (brandsIds.includes(product.brandId)) 
              && (colorsIds?.includes(product.colorId)) 
              && (materialsIds?.includes(product.materialId))
              && (product.price >= price[0] && product.price <= price[1])
            ) {
              filtered.push(product)
            }
          }
        )
    }

    handleFilterProducts(filtered)
      }
    }


     
    let storagesArr = []
    let brandsArr = []
    let colorsArr = []
    let modelsArr = []

    const [touched, setTouched] = useState(false)

    useEffect(() => {
      handleFilterOptions()
    }, [])

    useEffect(() => {
      if(touched) {
        handleFilterOptions("storage")
        getMaxProductPrice()
      }
    }, [storagesSelected])

    useEffect(() => {
      if(touched) {
        handleFilterOptions("brand")
        getMaxProductPrice()
      }
    }, [brandsSelected])

    useEffect(() => {
      if(touched) {
        handleFilterOptions("color")
        getMaxProductPrice()
      }
    }, [colorsSelected])

    useEffect(() => {
      if(touched) {
        handleFilterOptions("model")
        getMaxProductPrice()
      }
    }, [modelsSelected])

    useEffect(() => {
      handleFilterOptions()
    }, [price])



    const handleColorsCheck = async (event) => {
        setColorsSelected({
          ...colorsSelected,
          [event.target.name]: event.target.checked
        });
        setTouched(true)
    };
    

    const handleMaterialsCheck = async (event) => {
        setMaterialsSelected({
          ...materialsSelected,
          [event.target.name]: event.target.checked
        });
        console.log("COLOR###", materialsSelected)
        setTouched(true)
    };

    const handleBrandsCheck = async (event) => {
       setBrandsSelected({
          ...brandsSelected,
          [event.target.name]: event.target.checked
        });
        setTouched(true)
    };

    const handleStoragesCheck = (event) => {
      setStoragesSelected({
        ...storagesSelected, 
        [event.target.name]: event.target.checked
      });
      setTouched(true)
  };


  const handleModelsCheck = (event) => {
    setModelsSelected({
      ...modelsSelected, 
      [event.target.name]: event.target.checked
    });
    setTouched(true)
};



  const resetFilters = () => {
    setBrandsSelected(brandsObj)
    setColorsSelected(colorsObj)
    setStoragesSelected(storagesObj)
    setModelsSelected(modelsObj)
    setPrice([0, max])
    handleFilterProducts(colorsSelected, storagesSelected, price, true, brandsSelected, modelsSelected)
  }


  const handleCreateBrand = ((brandName) => {
    setOpenCreateBrand(false)
    createBrand({brandName: brandName}, { 
      headers: {
        'Token': `Bearer ${user?.accessToken}`
      }
    }).then(

    )
  })

  const handleCreateMaterial = ((materialName) => {
    console.log("material name is", materialName)
    setOpenCreateMaterial(false)
    createMaterial({materialName: materialName}, { 
      headers: {
        'Token': `Bearer ${user?.accessToken}`
      }
    }).then(

    )
  })

  const handleCreateStorage = ((data) => {
    setOpenCreateStorage(false)
    createStorage({amount: data.amount, type: data.type}, { 
      headers: {
        'Token': `Bearer ${user?.accessToken}`
      }
    }).then( res =>
    {

    }).catch(
    )
  })

  
  const handleCreateModel = ((modelName) => {
    setOpenCreateModel(false)
    createModel({modelName: modelName}, { 
      headers: {
        'Token': `Bearer ${user?.accessToken}`
      }
    }).then( res =>
    {

    }).catch(
    )
  })


  const handleCreateColor = ((data) => {
    setOpenCreateColor(false)
    createColor({colorName: data}, { 
      headers: {
        'Token': `Bearer ${user?.accessToken}`
      }
    }).then({
      
    }
    )
  })

  const theme = useTheme()
  const isXs= useMediaQuery(theme.breakpoints.down('xs'));
  const isSm= useMediaQuery(theme.breakpoints.down('sm'));
  const isMd= useMediaQuery(theme.breakpoints.down('md'));

  const openModalCreateBrand = ((brand) => {
    setOpenCreateBrand(true)
  })

  const openModalCreateStorage = ((brand) => {
    setOpenCreateStorage(true)
  })

  const openModalCreateColor = ((color) => {
    setOpenCreateColor(true)
  })

  const openModalCreateMaterial = ((material) => {
    setOpenCreateMaterial(true)
  })

  const openModalCreateModel = ((model) => {
    setOpenCreateModel(true)
  })




  const mobileSidebar = () => (
    <div id={!showSidebar && (isSm || isXs ) ? "hideSidebar" : ""}>
    <AppBar
        position="fixed"
    >
    </AppBar>
    <Drawer
        sx={{
        flexShrink: 0,
        '& .MuiDrawer-paper': {
            marginTop: '110px',
            marginBottom:'30px',
            paddingTop:'30px',
            paddingRight:'30px',
            paddingLeft:'30px',
            paddingBottom: '80px',
            width: '100%',
            height: '100%',
            boxSizing: 'border-box',
        },
        }}
        variant="permanent"
        anchor="left"
    >
      {(isSm || isXs) && 
      <Box sx={{display:'flex', justifyContent:'space-between'}}>
        <Button variant="contained" color="primary" sx={{width:'150px'}} onClick={() => setShowSidebar(false)}>Close Filters</Button>
        <Button color="secondary" variant="contained" sx={{width:'150px'}} onClick={() => resetFilters()}>Reset Filters</Button>
      </Box>
      }

        <>
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems:'center'}}>
            <h4>Color</h4>
            {user?.isAdmin && (
            <div>
            <Button  onClick={() => openModalCreateColor()} style={{width: '30px'}}>
              <AddIcon/>
            </Button>
            <CreateColorDialog openCreateColor={openCreateColor} handleCreate={handleCreateColor} setOpenCreateColor={setOpenCreateColor}>         
            </CreateColorDialog>
            </div>
            )}
          </div>
          
            {colors?.map((color) => (
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
              <FormControlLabel 
                control={<Checkbox checked={colorsSelected[color.colorName] ?? false} onChange={handleColorsCheck} name={color.colorName} />}
                label={color.colorName}
              />
              <div>
                <Color color={color}/>
              </div>
              
            </div>
            ))}
        </>
      
        <>
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems:'center'}}>
            <h4>Storage</h4>
            {user?.isAdmin && (
            <div>
              <Button onClick={() => openModalCreateStorage()} style={{width: '30px'}}>
                <AddIcon/>
              </Button>
              <CreateStorageDialog openCreateStorage={openCreateStorage} handleCreate={handleCreateStorage} setOpenCreateStorage={setOpenCreateStorage}>         
              </CreateStorageDialog>
            </div>
            )}
          </div>
          {storages?.map((storage) => (
            <div style={{display: 'flex', justifyContent: 'space-between'}}>       
              <FormControlLabel 
                control={<Checkbox checked={storagesSelected[storage.amount + storage.type] ?? false} onChange={handleStoragesCheck} name={storage.amount + storage.type} />}
                label={storage.amount + " " + storage.type}
              />
              <div>
                <Storage storage={storage}/>
              </div>
            </div>
            ))}
        </>



        <>
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems:'center'}}>
            <h4>Brand</h4>
            {user?.isAdmin && (
            <div>
              <Button  onClick={() => openModalCreateBrand()} style={{width: '30px'}}>
                <AddIcon/>
              </Button>
              <CreateBrandDialog openCreateBrand={openCreateBrand} handleCreate={handleCreateBrand} setOpenCreateBrand={setOpenCreateBrand}>         
              </CreateBrandDialog>
            </div>
            )}
          </div>
          
          <>
            {brands?.map((brand) => (
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
              <FormControlLabel 
                control={<Checkbox checked={brandsSelected[brand.brandName] ?? false} onChange={handleBrandsCheck} name={brand.brandName} />}
                label={brand.brandName}
              />
              <div>
                <Brand brand={brand}/>
              </div>
              
            </div>
            ))}
          </>
        </>
 
        <Box sx={{ width: 300 }}>
          <Typography id="input-slider" gutterBottom>
            Price
          </Typography>
          <Slider
            getAriaLabel={() => 'Price'}
            value={price}
            onChange={handlePrice}
            valueLabelDisplay="auto"
            disableSwap
            min={0}
            max={max}
          />
          <span>min:{price[0]}$ - max:{price[1]}$</span>
        </Box>
    </Drawer>
  </div>
  )

  const desktopSidebar = () => (
    <div>
    <Container
        sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
            width: drawerWidth,
            '&:hover': {
              overflowY: 'auto',
            },
            '&::-webkit-scrollbar': {
              display: 'none',
            },
        },
        }}
        variant="permanent"
        anchor="left"
    >
      {(isSm || isXs) && <Button variant="contained" color="primary" onClick={() => setShowSidebar(false)}>Close Sidebar</Button>
      }

        <>
          <div style={{display: 'flex', width:'100%', margin:'10px 0'}}>
            <Typography variant="h6" sx={{fontWeight:'bold', marginRight:'auto'}}>Color</Typography>
            {user?.isAdmin && (
            <>
            <Button  onClick={() => openModalCreateColor()} style={{width: '30px'}}>
              <AddIcon  fontSize="medium"/>
            </Button>
            <CreateColorDialog openCreateColor={openCreateColor} handleCreate={handleCreateColor} setOpenCreateColor={setOpenCreateColor}>         
            </CreateColorDialog>
            </>
            )}
          </div>
         
           <>
            {colors?.map((color) => (
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
              <FormControlLabel 
                control={<Checkbox checked={colorsSelected[color.colorName] ?? false} onChange={handleColorsCheck} name={color.colorName} />}
                label={color.colorName}
              />
              <div>
                <Color color={color}/>
              </div>
              
            </div>
            ))}
        </> 
      </>


      {type==="smartphone" &&
      <>
      <> 
        <div style={{display: 'flex', justifyContent: 'space-between', margin:'10px 0'}}>
            <Typography variant="h6" sx={{fontWeight:'bold', marginRight:'auto'}}>Storage</Typography>
            {user?.isAdmin && (
            <>
              <Button onClick={() => openModalCreateStorage()} style={{width: '30px'}}>
                <AddIcon fontSize="medium"/>
              </Button>
              <CreateStorageDialog openCreateStorage={openCreateStorage} handleCreate={handleCreateStorage} setOpenCreateStorage={setOpenCreateStorage}>         
              </CreateStorageDialog>
            </>
            )}
          </div>
        <>
          {!updated ? 
          <>
            {storages?.map((storage) => (
            <div style={{display: 'flex', justifyContent: 'space-between'}}>       
              <FormControlLabel 
                control={<Checkbox checked={storagesSelected[storage.amount + storage.type] ?? false} onChange={handleStoragesCheck} name={storage.amount + storage.type} />}
                label={storage.amount + " " + storage.type}
              />
              <div>
                <Storage storage={storage}/>
              </div>
            </div>
            ))}
          </> :
          <>
            {filteredStorages?.map((storage) => (
            <div style={{display: 'flex', justifyContent: 'space-between'}}>       
              <FormControlLabel 
                control={<Checkbox checked={storagesSelected[storage.amount + storage.type] ?? false} onChange={handleStoragesCheck} name={storage.amount + storage.type} />}
                label={storage.amount + " " + storage.type}
              />
              <div>
                <Storage storage={storage}/>
              </div>
            </div>
            ))}
          </>}
        </>
      </>
      
      <>
      <div style={{display: 'flex', justifyContent: 'space-between', margin:'10px 0'}}>
      <Typography variant="h6" sx={{fontWeight:'bold', marginRight:'auto' }}>Model</Typography>
        {user?.isAdmin && (
        <>
          <Button  onClick={() => openModalCreateModel()} style={{width: '30px'}}>
            <AddIcon fontSize="medium"/>
          </Button>
          <CreateModelDialog openCreateModel={openCreateModel} handleCreate={handleCreateModel} setOpenCreateModel={setOpenCreateModel}>         
          </CreateModelDialog>
        </>
        )}
      </div>
      
      {!updated ? 
      <>
        {models?.map((model) => (
        <div style={{display: 'flex', justifyContent: 'space-between'}}>
          <FormControlLabel 
            control={<Checkbox checked={modelsSelected[model.modelName] ?? false} onChange={handleModelsCheck} name={model.modelName} />}
            label={model.modelName}
          />
          <div>
            <Model model={model}/>
          </div>
          
        </div>
        ))}
      </> : 
      <>
        {filteredModels?.map((model) => (
          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <FormControlLabel 
            control={<Checkbox checked={modelsSelected[model.modelName] ?? false} onChange={handleModelsCheck} name={model.modelName} />}
            label={model.modelName}
            />
            <div>
              <Model model={model}/>
            </div>
            
          </div>
          ))}
      </>
      }
    </>
    </>
}   

        



        <>
          <div style={{display: 'flex', justifyContent: 'space-between', margin:'10px 0'}}>
          <Typography variant="h6" sx={{fontWeight:'bold', marginRight:'auto' }}>Brand</Typography>
            {user?.isAdmin && (
            <>
              <Button  onClick={() => openModalCreateBrand()} style={{width: '30px'}}>
                <AddIcon fontSize="medium"/>
              </Button>
              <CreateBrandDialog openCreateBrand={openCreateBrand} handleCreate={handleCreateBrand} setOpenCreateBrand={setOpenCreateBrand}>         
              </CreateBrandDialog>
            </>
            )}
          </div>
          
          {!updated ? 
          <>
            {brands?.map((brand) => (
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
              <FormControlLabel 
                control={<Checkbox checked={brandsSelected[brand.brandName] ?? false} onChange={handleBrandsCheck} name={brand.brandName} />}
                label={brand.brandName}
              />
              <div>
                <Brand brand={brand}/>
              </div>
              
            </div>
            ))}
          </> : 
          <>
            {filteredBrands?.map((brand) => (
              <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <FormControlLabel 
                control={<Checkbox checked={brandsSelected[brand.brandName] ?? false} onChange={handleBrandsCheck} name={brand.brandName} />}
                label={brand.brandName}
                />
                <div>
                  <Brand brand={brand}/>
                </div>
                
              </div>
              ))}
          </>
          }
                    
        </>


      {type==="phonecase" &&
        <>
          <div style={{display: 'flex', width:'100%', margin:'10px 0'}}>
            <Typography variant="h6" sx={{fontWeight:'bold', marginRight:'auto'}}>Material</Typography>
            {user?.isAdmin && (
            <>
            <Button  onClick={() => openModalCreateMaterial()} style={{width: '30px'}}>
              <AddIcon  fontSize="medium"/>
            </Button>
            <CreateMaterialDialog openCreateMaterial={openCreateMaterial} handleCreate={handleCreateMaterial} setOpenCreateMaterial={setOpenCreateMaterial}>         
            </CreateMaterialDialog>
            </>
            )}
          </div>
         
           <>
            {materials?.map((material) => (
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
              <FormControlLabel 
                control={<Checkbox checked={materialsSelected[material.materialName] ?? false} onChange={handleMaterialsCheck} name={material.materialName} />}
                label={material.materialName}
              />
              <div>
                <Material material={material}/>
              </div>
              
            </div>
            ))}
          </> 
      </>}




 
        <Box>
          <Typography id="input-slider" variant="h6" sx={{fontWeight:'bold', margin:'10px 0'}} gutterBottom>
            Price
          </Typography>
          <Slider
            getAriaLabel={() => 'Price'}
            value={price}
            onChange={handlePrice}
            valueLabelDisplay="auto"
            disableSwap
            min={0}
            max={max}
          />
          <span>min:0$ - max:${max}</span>
        </Box>
        <Button style={{marginTop: '10px'}} color="secondary" variant="contained" onClick={() => resetFilters()}>Reset Filter</Button>
    </Container>
  </div>
  )

  return (
    <div>
        {
        (isXs) ?  mobileSidebar() : 
        (isSm) ? mobileSidebar() :
        (isMd) ? desktopSidebar() :
        desktopSidebar()
      }
    </div>
  );
}

export default Sidebar